// FormContext.js
import React, { createContext, useContext, useState } from 'react';

// Criar o contexto
const FormContext = createContext();

// Provedor para envolver a aplicação
export const FormProvider = ({ children }) => {
    const [formAberto, setFormAberto] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [eventoSelecionado, setEventoSelecionado] = useState(null);

    return (
        <FormContext.Provider value={{ formAberto, setFormAberto, selectedDate, setSelectedDate, eventoSelecionado, setEventoSelecionado }}>
            {children}
        </FormContext.Provider>
    );
};

// Hook para usar o contexto
export const useFormContext = () => useContext(FormContext);
